(function () {
  function init () {
    const root = document.getElementById('home-library')
    if (!root) return
    const tabs = [...root.querySelectorAll('[role="tab"]')]
    const panels = [...root.querySelectorAll('[role="tabpanel"]')]
    const resume = document.getElementById('home-tab-resume')
    const hero = document.querySelector('main > .swiper.container')
    function syncReadiness () {
      const activePanel = panels.find(panel => !panel.hidden)
      const slider = activePanel && activePanel.querySelector('.swiper-cat')
      const ready = (!hero || hero.classList.contains('swiper-initialized')) && (!slider || slider.classList.contains('swiper-initialized'))
      if (root.classList.contains('home-library-ready') !== ready) root.classList.toggle('home-library-ready', ready)
    }
    function activate (tab) {
      if (tab.getAttribute('aria-selected') === 'true') return
      const panel = document.getElementById(tab.getAttribute('aria-controls'))
      const previousHeight = window.InoriginalTabMotion.capture(root)
      window.InoriginalTabMotion.prepare(root, panel)
      tabs.forEach(button => {
        const selected = button === tab
        button.setAttribute('aria-selected', String(selected))
        button.tabIndex = selected ? 0 : -1
      })
      panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls') })
      window.InoriginalTabMotion.reveal(root, panel, previousHeight)
      syncReadiness()
    }
    function sync () {
      resume.hidden = !root.querySelector('#swiper-main-resume .swiper-slide')
      const visible = tabs.filter(tab => !tab.hidden)
      root.hidden = !visible.length
      if (!visible.length) return
      const active = visible.find(tab => tab.getAttribute('aria-selected') === 'true')
      if (!active) activate(visible[0])
      syncReadiness()
    }
    tabs.forEach(tab => {
      tab.addEventListener('click', () => activate(tab))
      tab.addEventListener('keydown', event => {
        const visible = tabs.filter(button => !button.hidden)
        let index = visible.indexOf(tab)
        if (event.key === 'ArrowRight') index = (index + 1) % visible.length
        else if (event.key === 'ArrowLeft') index = (index + visible.length - 1) % visible.length
        else if (event.key === 'Home') index = 0
        else if (event.key === 'End') index = visible.length - 1
        else return
        event.preventDefault()
        activate(visible[index])
        visible[index].focus()
      })
    })
    new MutationObserver(sync).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] })
    if (hero) new MutationObserver(syncReadiness).observe(hero, { attributes: true, attributeFilter: ['class'] })
    sync()
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init)
  else init()
})()
